// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState = () =>( {
  myattendances: [],
  lastattendance: {},
  attendancetypes: [],    
});
const state = {
    myattendances: [],
    lastattendance: {},
    attendancetypes: [],    
  };

const getters = {
    myattendances: (state) => state.myattendances,
    lastattendance: (state) => state.lastattendance
  };
  
const mutations = {
    setmyAttendance(state, payload) {
        state.myattendances = payload;
    },
    clearmyAttendance(state) {
        state.myattendances = [];
    },
    setlastAttendance(state, payload) {
        state.lastattendance = payload;
    },
    setattendanceTypes(state, payload) {
        state.attendancetypes = payload;
    },
    RESET_STATE(state) {
      const newState = initialState();
      Object.keys(initialState).forEach(key => {
        state[key] = newState[key];
      });
    },
};

const actions = {
    getMyAttendance({ commit,getters }, payload) {
      commit("setLoading", true);
      commit("clearError");
  
      const u_name = payload.u_name;
  
      secure_axios
        .get(`${getters.sessionAPI}attendance?u_name=${u_name}`)
        .then((response) => {
          commit("setmyAttendance", response.data.attendance);
          commit("setlastAttendance", response.data.attendance[0]);
          commit("setLoading", false);
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);    
          commit("setLoading", false);
          commit("setError", error);
        });   
    }, 
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
